import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Flex, Button } from 'nallian-shared-ui/lib/components';

const FileName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const HistoryButton = styled(Button)`
  &&& {
    white-space: nowrap;
  }
`;

const DocumentNameRenderer = ({ value = '', item, onViewHistory }) => {
  const { t } = useTranslation();
  return (
    <Flex fluid justifyContent="space-between">
      <FileName title={value}>{value}</FileName>
      {onViewHistory && item.history?.length > 0 && (
        <HistoryButton linkbutton content={t('viewHistory')} onClick={() => onViewHistory(item)} />
      )}
    </Flex>
  );
};

DocumentNameRenderer.propTypes = {
  value: PropTypes.string,
  item: PropTypes.object.isRequired,
  onViewHistory: PropTypes.func,
};

export default DocumentNameRenderer;
